<template>
  <div class="box">
    <!--    顶部按钮组-->
    <div class="btn-group w-100" role="group" aria-label="Basic example">
      <div class="btn btn-light" v-for="(item,index) in list" :key="item.name" @click="current = index">
        <i class="fa fa-2x" :class="item.icon"></i><br><span>{{ item.name }}</span>
      </div>
    </div>
    <!--    对应系统教程-->
    <div class="content">
      <div id="course" class="row mt-4 mb-2">
        <div class="col-12 border-bottom">
          <!--          系统名称-->
          <h5 v-show="current===0" class="h5-sor"><i class="fa fa-apple fa-2x"></i>苹果IOS系统 <small class="text-muted">使用帮助</small>
          </h5>
          <h5 v-show="current===1" class="h5-sor"><i class="fa fa-android fa-2x"></i>安卓Android系统 <small
              class="text-muted">使用帮助</small></h5>
          <h5 v-show="current===2" class="h5-sor"><i class="fa fa-windows fa-2x"></i>Windows系统 <small
              class="text-muted">使用帮助</small></h5>
          <h5 v-show="current===3" class="h5-sor"><i class="fa fa-apple fa-2x"></i>MacOs系统 <small class="text-muted">使用帮助</small>
          </h5>
          <h5 v-show="current===4" class="h5-sor"><i class="fa fa-linux fa-2x"></i>Linux系统 <small class="text-muted">使用帮助</small>
          </h5>
        </div>
      </div>
      <!--      下载方式-->
      <div class="course w-100 border-bottom pb-1" v-show="current===0">
        <div class="row course-items d-flex border-bottom-dashed">
          <div class="col-1 align-self-center left">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>下载客户端</strong> 支持iPhone/iPad</p>
            <p class="mb-0">或商店搜索 Cisco Anyconnect</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <a href="https://itunes.apple.com/cn/app/cisco-anyconnect/id1135064690?mt=8" target="_blank"
               class="btn btn-primary align-self-center btn-block mr-1">
              去AppStore下载 <br> <small>(支持国内手机)</small>
            </a>
          </div>
        </div>
        <div class="row course-items d-flex border-bottom-dashed">
          <div class="col-1 align-self-center pr-0 left">
            <div class="alert alert-primary text-center p-0 m-0 " role="alert">建议做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>设置一键连接</strong> 1分钟搞定</p>
            <p class="mb-0">简便连接，仅需一次设置即可</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <button @click="scrollTo('video1')" class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程 <br> <small>(视频教程)</small>
            </button>
          </div>
        </div>
        <div class="row course-items d-flex">
          <div class="col-1 align-self-center pr-0 left">
            <div class="alert alert-success text-center p-0 m-0 " role="alert">高手做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>手工填写VPN信息</strong></p>
            <p class="mb-0">每次使用均需手动输入密码</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <button  @click="scrollTo('video2')" target="_blank" class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程 <br> <small>(视频教程)</small>
            </button>
          </div>
        </div>
      </div>
      <div class="course w-100 border-bottom pb-1" v-show="current===1">
        <div class="row course-items d-flex border-bottom-dashed">
          <div class="col-1 align-self-center left">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>下载客户端</strong> 支持手机/平板</p>
            <p class="mb-0">或商店搜索 Cisco Anyconnect</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <a :href="this.common.downHost+'/downloads/android/anyConnect_5.0.00247.apk'"
               class="btn btn-primary align-self-center btn-block mr-1 pt-3 pb-3">
              点击下载客户端
            </a>
          </div>
        </div>
        <div class="row course-items d-flex border-bottom-dashed">
          <div class="col-1 align-self-center pr-0 left">
            <div class="alert alert-primary text-center p-0 m-0 " role="alert">建议做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>设置一键连接</strong> 1分钟搞定</p>
            <p class="mb-0">简便连接，仅需一次设置即可</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <button  @click="scrollTo('video1')" target="_blank" class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程 <br> <small>(视频教程)</small>
            </button>
          </div>
        </div>
        <div class="row course-items d-flex">
          <div class="col-1 align-self-center pr-0 left">
            <div class="alert alert-success text-center p-0 m-0 " role="alert">高手做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>手工填写VPN信息</strong></p>
            <p class="mb-0">每次使用均需手动输入密码</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <button  @click="scrollTo('video2')" target="_blank" class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程 <br> <small>(视频教程)</small>
            </button>
          </div>
        </div>
      </div>
      <div class="course w-100 border-bottom pb-1" v-show="current===2">
        <div class="row course-items d-flex border-bottom-dashed">
          <div class="col-1 align-self-center left">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>下载客户端</strong></p>
            <p class="mb-0">支持Win7/Win10</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
<!--            <a :href="this.common.downHost+'/downloads/windows/anyconnect-win-4.8.03052-core-vpn-predeploy-k9.msi'"-->
            <a :href="this.common.downHost+'/downloads/windows/cisco-win-5.0.00556-core-vpn-predeploy-k9.msi'"
               class="btn btn-primary align-self-center btn-block mr-1 pt-3 pb-3">
              点击下载客户端
            </a>
          </div>
        </div>
        <div class="row course-items d-flex border-bottom-dashed">
          <div class="col-1 align-self-center left">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert" style="background: #D9001B">必须做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0">手工填写VPN信息</p>
            <p class="mb-0">需在客户端配置哦</p>
          </div>
          <div class="col-4 right_btn d-flex pl-0">
            <a  @click="scrollTo('video')" target="_blank"
               class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程<br><small>视频教程</small>
            </a>
          </div>
        </div>
      </div>
      <div class="course w-100" v-show="current===3">
        <div class="row course-items d-flex ">
          <div class="col-1 align-self-center pr-0 left_red">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-10 col-md-8 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>下载客户端</strong></p>
            <p class="mb-0">根据您的MacOS系统版本选择，否则无法安装成功</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex mt-2 pb-2 border-bottom-dashed">
<!--            <a :href="this.common.downHost+'/downloads/MacOS10.15/anyconnect-macos-4.8.03052-core-vpn-webdeploy-k9.dmg'"-->
            <a :href="this.common.downHost+'/downloads/macOS10.15/anyconnect-macos-4.10.08029-predeploy-k9.dmg'"
               class="btn btn-sm btn-primary align-self-center btn-block mr-1">
              MacOS Catalina
              <br> (OS 10.15.xx 以上)
            </a>
          </div>
          <div class="col-6 d-flex mt-2 pb-2 border-bottom-dashed">
<!--            <a :href="this.common.downHost+'/downloads/MacOS13-15/anyconnect-macos-4.7.04056-core-vpn-webdeploy-k9.dmg'"-->
            <a :href="this.common.downHost+'/downloads/macOS13-15/anyconnect-macos-4.10.08029-predeploy-k9.dmg'"
               class="btn btn-primary align-self-center btn-block mr-1">
              MacOS 其他版本 <br> (OS 10.15.xx 以下)
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-9 mt-2 d-flex border-bottom">
            <p class="align-self-center text-primary">
              <strong>如何查看MacOS操作系统版本？</strong>
              <br>1.点击屏幕左上角图标，选择关于本机(本机信息) <br>2.在窗口信息中查看版本即可 </p>
          </div>
          <div class="col-3 mt-2 d-flex pl-0 border-bottom">
            <a href="../../assets/download/macos_version.png" class="align-self-center"><img
                src="../../assets/download/macos_version.png" alt="示例图" class=" img-fluid"></a>
          </div>
        </div>
        <div class="row course-items d-flex">
          <div class="col-2 align-self-center pr-0">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-nowrap overflow-auto">
            <p class="mb-0"><strong>手工填写VPN信息</strong></p>
            <p class="mb-0">需在客户端配置哦</p>
          </div>
          <div class="col-4 d-flex pl-0">
            <button  @click="scrollTo('video')" class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程 <br> <small>(视频教程)</small>
            </button>
          </div>
        </div>
      </div>
      <div class="course w-100" v-show="current===4">
        <div class="row course-items d-flex ">
          <div class="col-1 align-self-center pr-0 left_red">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-10 col-md-8 offset-md-1 p-0 align-self-center text-wrap">
            <p class="mb-0"><strong>下载客户端</strong></p>
            <p class="mb-0">根据您的Linux系统架构选择，否则无法安装成功</p>
          </div>
        </div>
        <div class="row">
          <div class="col-6 d-flex mt-2 pb-2 border-bottom-dashed">
            <a :href="this.common.downHost+'/downloads/linux/anyconnect-linux64-4.10.08029-predeploy-deb-k9.tar.gz'"
               class="btn btn-sm btn-primary align-self-center btn-block mr-1">
              Debian/Ubuntu
              <br> (.deb)
            </a>
          </div>
          <div class="col-6 d-flex mt-2 pb-2 border-bottom-dashed">
            <a :href="this.common.downHost+'/downloads/linux/anyconnect-linux64-4.10.08029-predeploy-rpm-k9.tar.gz'"
               class="btn btn-primary align-self-center btn-block mr-1">
              Fedora/RedHat<br> (.rpm)
            </a>
          </div>
        </div>
<!--        <div class="row">-->
<!--          <div class="col-9 mt-2 d-flex border-bottom">-->
<!--            <p class="align-self-center text-primary">-->
<!--              <strong>如何查看Linux操作系统架构？</strong>-->
<!--              <br>执行命令：uname -a</p>-->
<!--          </div>-->
<!--        </div>-->
        <div class="row course-items d-flex">
          <div class="col-2 align-self-center pr-0">
            <div class="alert alert-danger text-center p-0 m-0 " role="alert">必须做</div>
          </div>
          <div class="col-6 col-md-5 offset-md-1 p-0 align-self-center text-nowrap overflow-auto">
            <p class="mb-0"><strong>手工填写VPN信息</strong></p>
            <p class="mb-0">需在客户端配置哦</p>
          </div>
          <div class="col-4 d-flex pl-0">
            <button  @click="scrollTo('video')" class="btn btn-primary align-self-center btn-block mr-1">
              看设置教程 <br> <small>(视频教程)</small>
            </button>
          </div>
        </div>
      </div>

      <div v-show="current===0 || current===1" class="course-tips mt-4 mb-2 row">
        <div class="col-12 d-flex">
          <a v-show="current===0"
             :href="'anyconnect://connect?name='+this.accessUser+'&amp;host='+this.common.linkStr+'&amp;prefill_username='+this.accessUser+'&amp;prefill_password='+this.accessPass"
             class="btn btn-block btn-success align-self-center">
            苹果IOS系统 &nbsp;&nbsp; 一键连接VPN </a>
          <a v-show="current===1"
             :href="'anyconnect://connect?name='+this.accessUser+'&amp;host='+this.common.linkStr+'&amp;prefill_username='+this.accessUser+'&amp;prefill_password='+this.accessPass"
             class="btn btn-block btn-success align-self-center">
            安卓Android &nbsp;&nbsp; 一键连接VPN </a>
        </div>
        <div class="col-12 mt-1">
          <small class="d-block px-2 m-0 text-danger">注意:一定要完成【一键连接设置】后再使用本功能，否则不会成功。<a
              href="#videoDiv">下方观看教程设置</a></small>
        </div>
      </div>
      <!--      视频-->
      <div v-show="current===0 || current===1">
        <div id="videoDiv" class="row mt-5 mb-2">
          <div class="col-12 border-bottom">
            <h5 class="h5-sor">
              <i class="fa" :class="current===0 ? 'fa-apple' : 'fa-android'"></i>设置一键连接 教程 <small class="float-right">
              <a v-show="current===0" class="mr-1" @click="goImageText('a1')">图文教程</a>
            </small>
            </h5>
          </div>
          <div class="col-12 w-100 mt-2">
            <div id="video1"
                 style="height: 400px; background-color: rgb(0, 0, 0); overflow: hidden; position: relative;">
              <div class="ckplayerchzwmprsllmgtdwiwx"
                   style="background-color: rgb(0, 0, 0); width: 100%; height: 100%;">
                <video-player v-show="current===0" id="chcpzjccspokrrnszz"  :options="video_help_ios" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
                <video-player v-show="current===1" id="chcpzjccspokrrnszz"  :options="video_help_android" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
              </div>
            </div>
          </div>
        </div>
        <div id="videoDiv2" class="row mt-5 mb-2">
          <div class="col-12 border-bottom">
            <h5 class="h5-sor">
              <i class="fa" :class="current===0 ? 'fa-apple' : 'fa-android'"></i>手工配置VPN信息 教程 <small
                class="float-right"><a class="mr-1" @click="goImageText('a2')">图文教程</a></small>
            </h5>
          </div>
          <div class="col-12 w-100 mt-2">
            <div id="video2"
                 style="height: 400px; background-color: rgb(0, 0, 0); overflow: hidden; position: relative;">
              <div class="ckplayerchtfkbindmdyugjupp"
                   style="background-color: rgb(0, 0, 0); width: 100%; height: 100%;">
                <video-player v-show="current===0" id="chvzwctizpdkhklodx"  :options="video_help_config_ios" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
                <video-player v-show="current===1" id="chvzwctizpdkhklodx"  :options="video_help_config_android" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-show="current===2 || current===3 || current===4" id="videoDiv3" class="row mt-4 mb-2">
        <div class="col-12 border-bottom">
          <h5 class="h5-sor"><i class="fa fa-windows "></i>配置VPN信息 教程</h5>
        </div>&nbsp;
        <br>
        <div class="col-12 w-100 mt-2">
          <div id="video" style="height: 700px; background-color: rgb(0, 0, 0); overflow: hidden; position: relative;">
            <div class="ckplayerchiiygntzeclfhuxpl" style="background-color: rgb(0, 0, 0); width: 100%; height: 100%;">
              <video-player v-show="current===2" id="chpnkfgcqetywvxwar1"  :options="video_help_windows" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
              <video-player v-show="current===3" id="chpnkfgcqetywvxwar2"  :options="video_help_macos" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
              <video-player v-show="current===4" id="chpnkfgcqetywvxwar3"  :options="video_help_macos" ref="videoPlayer" class="video-player vjs-custom-skin"  webkit-playsinline="true" :playsinline="true" x5-playsinline="true" x5-video-orientation="landscape" style="object-fit:fill;"></video-player>
            </div>
          </div>
        </div>
      </div>



    </div>
    <footerPage></footerPage>

  </div>
</template>

<script>
import footerPage from "@/components/userInfo/footer";
import {getToken, getUser} from "@/axios/token";
import qs from "qs";
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'


export default {
  name: "TutorialsPage",
  components:{footerPage},
  data() {
    return {
      current: 0,
      list: [
        {icon: 'fa-apple', name: 'IOS'},
        {icon: 'fa-android', name: 'Android'},
        {icon: 'fa-windows', name: 'Windows'},
        {icon: 'fa-apple', name: 'MacOs'},
        {icon: 'fa-linux', name: 'Linux'},
      ],
      accessUser: '',
      accessPass: '',
      video_help_ios: {
        autoplay: false,
        height: '400',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-ios.mp4',
          type: 'video/mp4'
        }],
      },
      video_help_android: {
        autoplay: false,
        height: '400',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-android.mp4',
          type: 'video/mp4'
        }],
      },
      video_help_config_ios: {
        autoplay: false,
        height: '400',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-config-ios.mp4',
          type: 'video/mp4'
        }],
      },
      video_help_config_android: {
        autoplay: false,
        height: '400',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-config-android.mp4',
          type: 'video/mp4'
        }],
      },
      video_help_windows: {
        autoplay: false,
        height: '700',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-windows.mp4',
          type: 'video/mp4'
        }],
      },
      video_help_macos: {
        autoplay: false,
        height: '700',
        preload: 'auto',
        controls: true,
        sources: [{
          src: this.common.downHost+'/video/help-macos.mp4',
          type: 'video/mp4'
        }],
      },
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },
  methods:{
    scrollTo(id){
      document.getElementById(id).scrollIntoView({ behavior: "smooth", block: 'center' });
    },
    goImageText(id){
      this.$router.push({
        name:'imageText',
        params:{
          id:id
        }
      })
    }
  },
  watch:{
    '$route.params':{
      immediate:true,
      deep:true,
      handler(n){
        this.list.forEach((item,i)=>{
          if(n.name === item.name) return this.current = i
        })
      }
    }
  },
  async mounted() {
    let data = {
      username:getUser()
    };
    await this.axios.post('/user/detail',qs.stringify(data), {
      headers:{
        "Jwt":getToken()
      }
    }).then(res=>{
      this.userData = res.data.data;
      this.accessUser = this.userData.username;
      this.accessPass = this.userData.pin_code;
      let dateString = this.userData.limittime; // 请替换为您的日期字符串

      let timestamp = new Date(dateString).getTime();
      let today = new Date(); // 获取当前日期
      this.useTime = Math.floor((timestamp - today) / (1000 * 60 * 60 * 24));
    });
  }
}
</script>

<style scoped>
@media (min-width: 300px) and (max-width: 767px) {
  .h5-sor {
    font-size: 1.3rem;
  }

  .h5-sor small {
    font-size: 75%;
  }

  .course {
    font-size: .8rem;
  }

  .course-items a {
    padding: 1px;
    font-size: .9rem;
  }

  .course-items > div:nth-child(1) {
    padding-right: 2px !important;
  }

  .course-items > div:nth-child(2) {
    padding-left: 5px !important;
  }

  .course-items a {
    height: 45px;
    border-radius: 10px;
  }

  .course-items button {
    height: 45px;
    border-radius: 10px;
    line-height: 1;
  }
}

@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }

  .container-md {
    max-width: 960px;
  }
}


html {
  height: 100%;
}

body {
  position: relative;
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 125px; /* .footer 的高度，为 footer 占位 */
}

footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 125px;
}

.course-items {
  height: 75px;
}

/*.course-items:nth-child(1)>div:nth-child(1)>div{*/
/*    background-color: red;*/
/*    color: white;*/
/*}*/

.course-items strong {
  font-size: 1rem;
  font-weight: 400;
}

.course-items .left_red {
  width: 3.5rem;
  margin-left: 10px;
  line-height: 1.2;
  padding: 5px !important;
}

.course-items .left {
  width: 3.5rem;
  margin-left: 10px;
  line-height: 1.2;
  padding: 5px !important;
}

.course-items .left div, .course-items .left_red div {
  color: white;
  border-radius: 10px;
  padding: 5px !important;
}

.course-items:nth-child(1) .left div, .course-items .left_red div {
  background-color: #D9001B;
}

.course-items:nth-child(2) .left div {
  background-color: #02A7F0;
}

.course-items:nth-child(3) .left div {
  background-color: #BFBF00;
}

.course-items .right_btn {
  -ms-flex: 0 0 36.333333%;
  flex: 0 0 36.333333%;
  max-width: 36.333333%;
  padding-right: 0;
}

.border-bottom-dashed {
  border-bottom: 1px dashed #dee2e6 !important;
}

.border-top-dashed {
  border-top: 1px dashed #dee2e6 !important;
}

</style>